let DUMMY_IMG= 'https://d3i4lqsaxjar6n.cloudfront.net/post_images/61958e4b490a7c0003244ab4/large.jpg'
export function getTemplate(a,type) {
  if(type=='webpage'){
    return  `
      <div style='display: flex; justify-content: space-around;'>

    <div style="margin-right: 50px;">
    <img  style="width: 300px; height: 300px;" src='${a.template.imageUrl || DUMMY_IMG}'/>
   </div>


  <div style="flex:1;">


      <h1 style="  font-family: 'Georgia','serif'; font-size: 30px;  font-weight: 500;"> ${formatTitle(
        a.name
      )}</h1>
      <p  style=" color:gray; font-family: 'Georgia','serif'; font-size: 16px;  " >
        ${a.description? a.description:""}
      </p>
      <h6  style="color: #414042; font-family: 'Georgia','serif'; font-size: 12px;  font-weight: 600;">${
      ""
      }</h6>
      <a href='${
      a.publishUrl
            }'>Read Story >></a>
  </div>
  </div>
    `

  }



  return ` 
    <mj-section class='vestorlyClass' background-color='#fff' >
      <mj-column width="300" height ='600' >

        <mj-image   width="430" height ='260' src="${a.template.imageUrl || DUMMY_IMG}">
        </mj-image>
      </mj-column>

      <mj-column >


    <mj-text padding-top="14px"   font-size="18px" color="#333"  font-family="Georgia,serif">  ${formatTitle(
      a.name
    )}</mj-text>
        <mj-text color='gray' font-size="14px" font-family="Georgia,serif">
        ${formatBody(a.description? a.description:"")}
        </mj-text>
      <mj-text padding-top='5px' color='#414042' font-weight='400'>${
""      }

        </mj-text>
        <mj-text>
      <p>
            <a style="text-decoration:none; color:#343434"href="${a.publishUrl}">Read Story >></a>
          </p>
        </mj-text>



      </mj-column>
    </mj-section>
        
        `;
}

function formatTitle(title) {
  if (title.length < 60) return title.toUpperCase();
  else return title.substring(0, 60).toUpperCase() + "...";
}

export function formatBody(body) {
  if (body.length < 60) return body;
  else return body.substring(0, 60) + "...";
}

const axios = require("axios");

export const getToken = () => {
  if (localStorage.getItem("keptLogged") == "true") {
    return localStorage.getItem("token") || null;
  }
  return sessionStorage.getItem("token") || null;
};

export const getCats = async () => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + "CRM/vestorly/customfeeds",
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getArticles = async () => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
      `campaigns/published?category=Blogs`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
  // const response = await axios.get(
  //   process.env.REACT_APP_API_BASE_URL +
  //     `CRM/vestorly/customfeeds/${id}/articles`,
  //   {
  //     headers: {
  //       Authorization: "Bearer " + getToken(),
  //     },
  //   }
  // );
  // return response.data;
};
